import { uniqBy } from 'lodash'

import { useFinderContext } from 'screens/Finder/FinderContext'
import { AttributeProperties, DefaultType, PROPERTY_TYPES_FOR_SHORTCUT } from 'api/clients/PropertyClient'
import { Property } from 'api/clients/PropertyClient'
import { useProperties as useReduxProperties } from 'hooks/useProperties'
import { ViewType } from 'types'

export const useFilterProperties = ({
  excludedProperties,
}: {
  excludedProperties: DefaultType[]
}): [Property[], number[]] => {
  const { filesView } = useFinderContext()
  const { propertiesUsableInCurrentFolder, fromStore } = useReduxProperties()
  const shortlistOfProperties = propertiesUsableInCurrentFolder.filter(
    ({ scope_project_id, default_type }) =>
      scope_project_id || (default_type && PROPERTY_TYPES_FOR_SHORTCUT.includes(default_type)),
  )
  const shownPropertyIds = fromStore(filesView?.schema.properties || []).map((p) => p.id)
  const hiddenPropertyIds = shortlistOfProperties
    .filter((property: Property) => {
      return !shownPropertyIds.includes(property.id)
    })
    .map((p) => p.id)

  const sortedProperties = propertiesUsableInCurrentFolder
    .filter((p) => !p.default_type || !excludedProperties.includes(p.default_type))
    .sort((a, b) => hiddenPropertyIds.indexOf(a.id) - hiddenPropertyIds.indexOf(b.id))
  const firstProperty = excludedProperties.includes(DefaultType.Name) ? [] : [AttributeProperties.name]
  const properties = uniqBy([...firstProperty, ...sortedProperties], 'id').filter(
    (p) => filesView?.schema.default_view !== ViewType.Calendar || p.id !== filesView?.schema.calendar_property_id,
  )
  return [properties, hiddenPropertyIds]
}
